import { render } from "./ConsultaFichaEpiNew.vue?vue&type=template&id=6ad4a23f&scoped=true"
import script from "./ConsultaFichaEpiNew.vue?vue&type=script&lang=js"
export * from "./ConsultaFichaEpiNew.vue?vue&type=script&lang=js"

import "./ConsultaFichaEpiNew.vue?vue&type=style&index=0&id=6ad4a23f&lang=css"
import "./ConsultaFichaEpiNew.vue?vue&type=style&index=1&id=6ad4a23f&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad4a23f"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QCarouselControl from 'quasar/src/components/carousel/QCarouselControl.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QIcon,QInput,QPopupProxy,QDate,QBtn,QSelect,QSpinner,QCheckbox,QTooltip,QPagination,QBadge,QMenu,QList,QItem,QItemSection,QLinearProgress,QDialog,QCard,QCardSection,QSpace,QImg,QTable,QTd,QCardActions,QItemLabel,QCarousel,QCarouselSlide,QCarouselControl,QField});qInstall(script, 'directives', {ClosePopup});
